<div class="relative" *transloco="let t">
	<button class="absolute right-2 top-2 z-10" mat-icon-button (click)="close(false)" [attr.aria-label]="t('commonActions.close')">
		<mat-icon>close</mat-icon>
	</button>
	<h1 mat-dialog-title cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">{{ t('tenantunits.selectTenantUnit') }}</h1>
	<mat-dialog-content>
		<div class="flex flex-col">
			<div class="flex flex-row items-center">
				<mat-form-field appearance="fill" class="w-[90%]">
					<mat-label>{{ t('realestates.choose') }}</mat-label>
					<mat-select [formControl]="realEstateFc" (selectionChange)="loadTenantUnits()">
						<mat-select-trigger>
							<div class="font-bold">{{ realEstateFc.value?.area }}/{{ realEstateFc.value?.realEstateNumber }}</div>
							<div class="font-light">{{ realEstateFc.value?.realEstateAddressStreet }},</div>
							<div class="font-light">
								{{ realEstateFc.value?.realEstateAddressZipCode }}
								{{ realEstateFc.value?.realEstateAddressCity }}
							</div>
						</mat-select-trigger>
						@for (realEstate of realEstates(); track realEstate.realEstateId) {
							<mat-option [value]="realEstate">
								<div class="font-bold">{{ realEstate?.area }}/{{ realEstate?.realEstateNumber }}</div>
								<div class="font-light">
									{{ realEstate.realEstateAddressStreet }}, {{ realEstate.realEstateAddressZipCode }} {{ realEstate.realEstateAddressCity }}
								</div>
							</mat-option>
						}
					</mat-select>
				</mat-form-field>
				<button mat-icon-button type="button" (click)="openRealEstatesSelectDialog()"><mat-icon>search</mat-icon></button>
			</div>
			@if (realEstateFc.value && tenantUnits()) {
				@if (tenantUnits().length === 0) {
					<mat-error>
						{{ t('tenantunits.noTenantUnits') }}
					</mat-error>
				} @else {
					<mat-form-field appearance="fill" class="w-full">
						<mat-label>{{ t('tenantunits.choose') }}</mat-label>
						<mat-select [formControl]="tenantUnitFc">
							<mat-select-trigger>
								<div class="font-bold">{{ tenantUnitFc.value?.number }}/{{ tenantUnitFc.value?.subNumber }}</div>
								@if (tenantUnitFc.value?.currentOwner) {
									<div class="font-light">
										{{ t('common.owner') }}: {{ getPersonName(tenantUnitFc.value.currentOwner.person) }} ({{ t('common.since') }}
										{{ dateUtil.setDateFormatByActiveLang(tenantUnitFc.value.currentOwner.validFrom, '-', false, true)
										}}{{
											tenantUnitFc.value.currentOwner.propertyManagementNumber
												? '; ' + tenantUnitFc.value.currentOwner.propertyManagementNumber
												: ''
										}})
									</div>
								}
								@if (tenantUnitFc.value?.currentResident) {
									<div class="font-light">
										{{ t('common.resident') }}: {{ getPersonName(tenantUnitFc.value.currentResident.person) }} ({{ t('common.since') }}
										{{ dateUtil.setDateFormatByActiveLang(tenantUnitFc.value.currentResident.validFrom, '-', false, true)
										}}{{
											tenantUnitFc.value.currentResident.propertyManagementNumber
												? '; ' + tenantUnitFc.value.currentResident.propertyManagementNumber
												: ''
										}})
									</div>
								}
							</mat-select-trigger>
							@for (tenantUnit of tenantUnits(); track tenantUnit.id) {
								<mat-option [value]="tenantUnit">
									<div class="font-bold">{{ tenantUnit.number }}/{{ tenantUnit.subNumber }}</div>
									@if (tenantUnit.currentOwner) {
										<div class="font-light">
											{{ t('common.owner') }}: {{ getPersonName(tenantUnit.currentOwner.person) }} ({{ t('common.since') }}
											{{ dateUtil.setDateFormatByActiveLang(tenantUnit.currentOwner.validFrom, '-', false, true)
											}}{{
												tenantUnit.currentOwner.propertyManagementNumber ? '; ' + tenantUnit.currentOwner.propertyManagementNumber : ''
											}})
										</div>
									}
									@if (tenantUnit.currentResident) {
										<div class="font-light">
											{{ t('common.resident') }}: {{ getPersonName(tenantUnit.currentResident.person) }} ({{ t('common.since') }}
											{{ dateUtil.setDateFormatByActiveLang(tenantUnit.currentResident.validFrom, '-', false, true)
											}}{{
												tenantUnit.currentResident.propertyManagementNumber
													? '; ' + tenantUnit.currentResident.propertyManagementNumber
													: ''
											}})
										</div>
									}
								</mat-option>
							}
						</mat-select>
					</mat-form-field>
				}
			}
		</div>
	</mat-dialog-content>
	@if (this.finishedLoading()) {
		<mat-dialog-actions class="flex flex-row justify-end items-center" mat-dialog-actions>
			<button (click)="close(true)" [disabled]="!tenantUnitFc.value" class="m-2" color="primary" mat-raised-button>
				<mat-icon>save</mat-icon>
				<span>
					{{ t('commonActions.select') }}
				</span>
			</button>
		</mat-dialog-actions>
	} @else {
		<div class="flex flex-1 flex-row justify-center mb-5">
			<mat-spinner color="primary"></mat-spinner>
		</div>
	}
</div>
